import React, { useState, useEffect } from "react";
import axios from "axios";
import { Redirect } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";
import { FaEdit, FaSave } from "react-icons/fa";
import MyLoader from "../Spinner/MyLoader";
import SessionManager from "../Utils/SessionManager";
import myToast from "../Utils/MyToast";
import "../css/Admin_css/class-settings-modals.css";

//Created By Cursor
const MdlRenameClass = ({ actionClose, selectedClass }) => {
  const token = localStorage.getItem("token");
  const [loggedIn] = useState(!!token);
  const [loading, setLoading] = useState(false);
  const [className, setClassName] = useState("");
  const [classNameOld, setClassNameOld] = useState("");

  useEffect(() => {
    if (selectedClass) {
      setClassName(selectedClass.class_name || "");
      setClassNameOld(selectedClass.class_name || "");
    }
  }, [selectedClass]);

  //Created By Cursor
  const handleRenameSubmit = async () => {
    if (!className.trim()) {
      myToast.notify_warning("Please enter a class name");
      return;
    }

    setLoading(true);
    try {
      const SCHOOL_CODE = SessionManager.getSchoolCode();
      const mStaffData = SessionManager.getStaffDetails();
      const STAFF_ID = mStaffData.staff_id;
      const URL = `${process.env.REACT_APP_SERVER_NAME}${process.env.REACT_APP_TARGET_DIR}updateClassName.php`;

      const response = await axios.get(URL, {
        params: {
          school_code: SCHOOL_CODE,
          staff_id: STAFF_ID,
          class_id: selectedClass.class_id,
          class_name_old: classNameOld,
          class_name_new: className.trim(),
          session_id: selectedClass.session_id,
        },
      });

      if (response.data.api_status === "OK") {
        myToast.notify_success("Class renamed successfully!");
        actionClose();
      } else {
        myToast.notify_warning(
          response.data.api_remark || "Rename failed. Please try again."
        );
      }
    } catch (error) {
      console.error("Rename error:", error);
      myToast.notify_error("An error occurred while renaming the class.");
    } finally {
      setLoading(false);
    }
  };

  if (!loggedIn) return <Redirect to="/Login" />;

  return (
    <Modal
      show={true}
      size="md"
      onHide={actionClose}
      animation={false}
      centered
      dialogClassName="cls-mdl-root"
      aria-labelledby="rename-class-title"
    >
      <Modal.Header closeButton>
        <div>
          <Modal.Title id="rename-class-title">
            <FaEdit />
            Rename Class
          </Modal.Title>
          <span className="cls-mdl-sub">
            Update the display name for this class
          </span>
        </div>
      </Modal.Header>

      <Modal.Body>
        {loading ? (
          <MyLoader />
        ) : (
          <div className="cls-mdl-panel">
            {classNameOld ? (
              <div className="cls-mdl-chip">
                <i className="fa fa-tag" aria-hidden="true" />
                Current: {classNameOld}
              </div>
            ) : null}
            <label className="cls-mdl-field full">
              <span>New Class Name *</span>
              <input
                type="text"
                required
                placeholder="Enter new class name"
                value={className}
                onChange={(e) => setClassName(e.target.value)}
              />
            </label>
          </div>
        )}
      </Modal.Body>

      <Modal.Footer>
        <Button className="cls-mdl-btn-ghost" onClick={actionClose}>
          Cancel
        </Button>
        <Button
          className="cls-mdl-btn-cta"
          onClick={handleRenameSubmit}
          disabled={loading}
        >
          <FaSave style={{ marginRight: 6 }} />
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default MdlRenameClass;
